module.exports = __webpack_public_path__ + "img/style.bf32e815.png";